import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PhotoProxyPipe } from "./photo-proxy.pipe";

@NgModule({
  declarations: [PhotoProxyPipe],
  imports: [CommonModule],
  exports: [PhotoProxyPipe],
})
export class SharedPipesModule {}
